// extracted by mini-css-extract-plugin
export default {"container":"qO1rZ4","label":"qgn3P3","tooltipContainer":"huJ3re","nameContainer":"hgYe8E","nameButton":"MPUN_B","name":"Q7CKkp","tooltip":"Cv20c1","loader":"smS6aI"};